import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { MultipleFileUploadField } from "../components/FileUpload/MultipleFileUploadField";
import Textarea from "../components/Form/Textarea";
import InputText from "../components/Form/InputText";
import RadioGroup from "../components/Form/RadioGroup";

export const WITH_APP = "MobileApp";
export const WITH_TRAVELCARD = "TravelCard";
export const WITH_BLIP = "PaymentCard";
export const WITH_TICKET = "PaperSlip";
export const NO_TICKET = "None";

export default function TicketType() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {

                    const resetTicketNumber =
                        values.ticketType !== formData.ticketType ? "" : formData.ticketNumber;
                        
                    setFormData({
                        ...formData,
                        ...values,
                        ticketNumber: resetTicketNumber,
                    });

                    if (values.ticketType === WITH_APP) {
                        navigate("/biljett-med-app");
                    } else if (values.ticketType === WITH_TRAVELCARD) {
                        navigate("/biljett-med-resekort");
                    } else if (values.ticketType === WITH_BLIP) {
                        navigate("/biljett-med-blipp");
                    } else if (values.ticketType === WITH_TICKET) {
                        navigate("/pappersbiljett");
                    } else if (values.ticketType === NO_TICKET) {
                        navigate("/vad-var-det-som-hande");
                    }
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    ticketType: Yup.string().test(
                        "at-least-one-radio-selected",
                        "Frågan “Var fanns biljetten?” saknar svar",
                        (value) => {
                            return value === WITH_APP ||
                                value === WITH_TRAVELCARD ||
                                value === WITH_BLIP ||
                                value === WITH_TICKET ||
                                value === WITH_TRAVELCARD ||
                                value === NO_TICKET;
                        }
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"22"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="ticketDetailsHeading">
                                    Var fanns biljetten?
                                </h2>

                                <p>
                                    För att kunna hjälpa dig behöver vi veta var biljetten fanns. Välj ett av alternativen för att gå vidare.
                                    Om det inte fanns någon biljett, välj ”Inget av ovanstående/det fanns ingen biljett”.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <RadioGroup name="ticketType" options={[
                                    { id: "MobileApp", value: "MobileApp", label: "I appen" },
                                    { id: "TravelCard", value: "TravelCard", label: "På ett reskort" },
                                    { id: "PaymentCard", value: "PaymentCard", label: "Blippat betalkort ombord" },
                                    { id: "PaperSlip", value: "PaperSlip", label: "Pappersbiljett" },
                                    { id: "None", value: "None", label: "Inget av ovanstående/det fanns ingen biljett" },
                                ]} />
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
